import { getAll, getById } from "@/utilities/querySelector";

document.addEventListener( 'DOMContentLoaded', initialise );


function initialise() {
    const buttons = getAll( '[data-form-toggle], [href="#enquiry-form"]' );
    buttons.forEach( ( button ) => {
        button.addEventListener( 'click', clickHandler );
    } );
}

function clickHandler( e ) {
    const form = getSiteForm();
    form.hasAttribute( 'open' ) ? closeForm() : openForm();
}

export function getSiteForm() {
    return /** @type {HTMLDialogElement} */ ( getById( 'site-footer-form-wrapper' ) );
}

export function openForm() {
    getSiteForm().setAttribute( 'open', '' );
}

export function closeForm() {
    getSiteForm().removeAttribute( 'open' );
}